import { apiClient } from './client';

/**
 * 게시판 댓글 API (게시판 v1 U3 · 2026-09-15).
 *
 * backend: apps/chat-server/src/modules/board/board-comment.routes.ts — **기존 라우트 그대로**다.
 * 다중 게시판 글(`/boards/*`)도 같은 `board_posts` 표라 이 경로가 그 글의 댓글을 다룬다.
 *
 * ⚠⚠ 서버 요청 R12 — 이 경로의 GET · POST 는 **다중 게시판 읽기 권한을 확인하지 않는다**
 *    (비공개 게시판 글도 id 만 알면 읽고 쓸 수 있다). 댓글 탭은 서버 수정 전 **배포 금지**(PR 선행 조건).
 *
 * 서버 규칙(실측):
 *   - 목록은 삭제되지 않은 댓글만 준다(삭제된 댓글은 자리도 없다) · 최대 200 · 뿌리 + 답글 한 단계
 *   - 답글의 부모는 뿌리 댓글이어야 한다
 *   - 수정은 댓글 작성자만 · 삭제는 댓글 작성자 · 글 작성자 · 회사 관리자
 */

export interface BoardCommentDto {
  id: string;
  content: string;
  parentCommentId: string | null;
  createdAt: string;
  author: { id: string; name: string };
  replies?: BoardCommentDto[];
}

export async function listBoardPostComments(postId: string): Promise<BoardCommentDto[]> {
  const { data } = await apiClient.get<{ comments: BoardCommentDto[] }>(`/board/posts/${postId}/comments`);
  return Array.isArray(data?.comments) ? data.comments : [];
}

export async function createBoardPostComment(
  postId: string,
  input: { content: string; parentCommentId?: string | null },
): Promise<BoardCommentDto> {
  const body = input.parentCommentId ? { content: input.content, parentCommentId: input.parentCommentId } : { content: input.content };
  const { data } = await apiClient.post<{ comment: BoardCommentDto }>(`/board/posts/${postId}/comments`, body);
  return data.comment;
}

export async function updateBoardComment(commentId: string, content: string): Promise<BoardCommentDto> {
  const { data } = await apiClient.patch<{ comment: BoardCommentDto }>(`/board/comments/${commentId}`, { content });
  return data.comment;
}

export async function deleteBoardComment(commentId: string): Promise<void> {
  await apiClient.delete(`/board/comments/${commentId}`);
}
